import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DataTable from '../DataTable/index.jsx';

import Columns from './Columns/index.jsx';

import {fetch as fetchAssets, isAssetsLoading, getAssetById, getAllAssets, getRatedAssets} from '../../Store/assets.js';
import { fetch as fetchPortfolio, isPortfolioLoading, getAssetQuantityById } from '../../Store/portfolio.js';
import { fetch as fetchUserPreferences, getUserPreferences, hideAssetTableColumn, setAssetTableSort, showAssetTableColumn } from '../../Store/user-preferences.js';


const AssetList = function(props) {
  return (
    <DataTable
      loading={props.loading}
      fetch={props.fetch}
      columns={props.columns}
      rows={props.assets}
      columnVisibility={props.assetTableColumns}
      hideColumn={props.hideColumn}
      showColumn={props.showColumn}
      sort={props.sort}
      setSort={props.setSort}
    />
  );
}


AssetList.propTypes = {
  showPortfolio: PropTypes.bool,
  assets: PropTypes.array
};


const mapStateToProps = function(state, ownProps) {
  var userPreferences = getUserPreferences(state);
  var assets;

  var additionalProps = {};

  if (ownProps.showPortfolio) {
    additionalProps.loading = isAssetsLoading(state) || isPortfolioLoading(state);
  } else {
    additionalProps.loading = isAssetsLoading(state);
  }

  additionalProps.columns = Columns(ownProps.showPortfolio);

  // only include the assets we care about if they've been provided 
  if (ownProps.assets && ownProps.assets.length) {
    assets = [];
    for (var i = 0; i < ownProps.assets.length; i++) {
      var asset = getAssetById(state, ownProps.assets[i]);

      if (asset) {
        assets.push(asset);
      }
    }
  } else {
    // Filter the asset list as per Show only Rated asset is checked or not
      if (ownProps.showOnlyRatedAssets) {
        assets = getRatedAssets(state);
      } else {
        assets = getAllAssets(state);
      }
  }

  // merge in the member's portfolio details.
  if (ownProps.showPortfolio) {
    var newAssets = [];
    for (const element of assets) {
      // we need to make a copy of the state object, as we're going to modify
      // the objects
      const tmp = Object.assign({}, element);

      const quantity = getAssetQuantityById(state, tmp.id, ownProps.portfolioId);

      tmp.heldAmount = quantity;
      tmp.heldValue = (tmp.price * quantity);
      newAssets.push(tmp);
    }
    assets = newAssets;
  }

  additionalProps.assetTableColumns = userPreferences.assetTableColumns;
  additionalProps.sort = userPreferences.assetTableSort;
  additionalProps.assets = assets.map((asset) => ({...asset, portfolioId: ownProps.portfolioId }));

  return additionalProps;
};

var mapDispatchToProps = function(dispatch, ownProps) {
  return {
    fetch: function() {
      dispatch(fetchUserPreferences());
      dispatch(fetchAssets());

      if (ownProps.showPortfolio) {
        dispatch(fetchPortfolio());
      }
    },
    hideColumn: function(column) {
      dispatch(hideAssetTableColumn(column));
    },
    setSort: function(column) {
      dispatch(setAssetTableSort(column));
    },
    showColumn: function(column) {
      dispatch(showAssetTableColumn(column));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AssetList);

